import type { ColumnOptions } from "interfaces";

export interface AccountColumnOptions extends ColumnOptions {
  propName: string;
}

export enum FiltersEnum {
  Tags = "tags",
  AddedDate = "dateCreated",
  AccountType = "accountTypeIds",
}
